class OffcanvasVanilla {
    constructor(offcanvasId, options = {}) {
        this.offcanvasId = offcanvasId;
        this.offcanvas = document.getElementById(offcanvasId);
        this.backdrop = document.querySelector(`[data-offcanvas-backdrop="${offcanvasId}"]`);
        this.trigger = document.querySelector(`[data-offcanvas-toggle="${offcanvasId}"]`);
        this.closeBtn = document.querySelector(`[data-offcanvas-close="${offcanvasId}"]`);

        this.direction = this.offcanvas.classList.contains('offcanvas-custom-end') ? 'end' : 'start';

        this.options = {
            keyboard: true,
            backdrop: true,
            backdropClose: true,
            animationDuration: 300,
            ...options
        };

        this.isOpen = false;

        this.init();
    }

    init() {
        if (!this.offcanvas) {
            console.error(`Offcanvas #${this.offcanvasId} no encontrado`);
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        // ✅ Cambio principal: usar toggle() en lugar de open()
        if (this.trigger) {
            this.trigger.addEventListener('click', () => this.toggle());
        }

        // Botón de cierre específico (opcional, si quieres tener uno dedicado)
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }

        // Backdrop click
        if (this.backdrop && this.options.backdropClose) {
            this.backdrop.addEventListener('click', () => this.close());
        }

        // ESC key
        if (this.options.keyboard) {
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.isOpen) {
                    this.close();
                }
            });
        }

        // Links que cierran automáticamente
        const dismissLinks = this.offcanvas.querySelectorAll('[data-offcanvas-dismiss]');
        dismissLinks.forEach(link => {
            link.addEventListener('click', () => this.close());
        });
    }

    open() {
        if (this.isOpen) return;

        this.isOpen = true;

        document.body.style.overflow = 'hidden';

        this.offcanvas.classList.add('show');
        if (this.backdrop && this.options.backdrop) {
            this.backdrop.classList.add('show');
        }
        if (this.trigger) {
            this.trigger.classList.add('offcanvas-open');
            // Actualizar aria para accesibilidad
            this.trigger.setAttribute('aria-expanded', 'true');
        }

        this.dispatchEvent('open');
    }

    close() {
        if (!this.isOpen) return;

        this.isOpen = false;

        document.body.style.overflow = '';

        this.offcanvas.classList.remove('show');
        if (this.backdrop) {
            this.backdrop.classList.remove('show');
        }
        if (this.trigger) {
            this.trigger.classList.remove('offcanvas-open');
            // Actualizar aria para accesibilidad
            this.trigger.setAttribute('aria-expanded', 'false');
        }

        this.dispatchEvent('close');
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    dispatchEvent(eventName) {
        const event = new CustomEvent(`offcanvas.${eventName}`, {
            detail: { offcanvasId: this.offcanvasId, direction: this.direction }
        });
        this.offcanvas.dispatchEvent(event);
    }

    destroy() {
        this.close();
    }
}

window.OffcanvasVanilla = OffcanvasVanilla;
document.addEventListener('DOMContentLoaded', function() {
    const offcanvasElements = document.querySelectorAll('[data-offcanvas-toggle]');

    offcanvasElements.forEach(trigger => {
        const targetId = trigger.getAttribute('data-offcanvas-toggle');
        if (targetId && !window[`offcanvas_${targetId}`]) {
            window[`offcanvas_${targetId}`] = new OffcanvasVanilla(targetId);
        }
    });
});
